var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import Container from "../container";
import TemplateArea from "./templateArea";
import TemplatePosition from "./templatePosition";
var Template = /** @class */ (function (_super) {
    __extends(Template, _super);
    function Template() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Template.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className;
        return (React.createElement("div", { className: className },
            React.createElement(Container, null, children)));
    };
    Template.Area = TemplateArea;
    Template.Position = TemplatePosition;
    return Template;
}(React.Component));
export default Template;



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/template/template.tsx
// module id = myoS
// module chunks = 2